module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasKey()),
      expression: "hasKey()"
    }],
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    staticClass: "deep-orange--text mr-2"
  }, [_vm._v("warning")]), _vm._v(" "), (_vm.hasPass()) ? _c('span', {
    staticClass: "deep-orange--text"
  }, [_vm._v(_vm._s(_vm.$t('keyFoot.keyAndPassWarning')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('keyFoot.keyWarning')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v(_vm._s(_vm.$t('keyFoot.forget')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08c5b57a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KeyFoot.vue
// module id = 1048
// module chunks = 1